export default __webpack_public_path__ + "static/media/after@2x.8af5b4a2.png";